import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Learning assistant chat is deprecated for now (explore-dev-api chat removed).
 */
const ChatPage = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: 'var(--color-bg)',
    }}
  >
    <div
      style={{
        maxWidth: 420,
        padding: 28,
        borderRadius: 16,
        border: '1px solid var(--color-border)',
        background: 'var(--color-bg-card)',
        textAlign: 'center',
        boxShadow: '0 4px 24px var(--color-shadow)',
      }}
    >
      <div style={{ fontSize: 44, marginBottom: 12 }} aria-hidden>💬</div>
      <h1 style={{ margin: '0 0 12px', fontSize: '1.35rem' }}>Learning assistant unavailable</h1>
      <p style={{ margin: '0 0 18px', lineHeight: 1.55, opacity: 0.85 }}>
        Chat is temporarily turned off while we move Explore services to the Kiddoware backend. Guided
        lessons and supervised web search are still available.
      </p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          padding: '12px 18px',
          borderRadius: 10,
          background: 'var(--color-primary)',
          color: '#fff',
          fontWeight: 700,
          textDecoration: 'none',
        }}
      >
        Back to Home
      </Link>
    </div>
  </div>
);

export default ChatPage;
